import {
  Stack,
  Typography,
  FormControl,
  TextField,
  FormHelperText,
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from '@mui/material';
import { type Control, Controller } from 'react-hook-form';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DescriptionIcon from '@mui/icons-material/Description';

import { type EditAuditFormBackgroundData } from '#apps/client-web/pages/audit-form-background/types';
import { getFormErrorAttributes } from '#apps/client-web/app/helpers/react-hook-form';
import { BACKGROUND_FIELD_DESCRIPTIONS } from '#apps/client-web/features/audit-form-background/constants';
import { useFormDescriptions } from '#apps/client-web/features/settings/hooks/use-form-descriptions';

export type OtherFieldsProps = {
  control: Control<EditAuditFormBackgroundData>;
  disableForm: boolean;
};

export const OtherFields = ({ control, disableForm }: OtherFieldsProps) => {
  const getDescription = useFormDescriptions(BACKGROUND_FIELD_DESCRIPTIONS);

  return (
    <Accordion variant="outlined">
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1-content"
        id="panel1-header">
        <Stack direction="row" alignItems="center" spacing={1}>
          <DescriptionIcon fontSize="small" />
          <Typography variant="body1">Other</Typography>
        </Stack>
      </AccordionSummary>
      <AccordionDetails>
        <Stack spacing={3}>
          <Controller
            control={control}
            name="other.endOfLifeAssets"
            disabled={disableForm}
            render={({ field, fieldState }) => (
              <FormControl
                fullWidth
                {...getFormErrorAttributes(fieldState.error)}>
                <TextField
                  {...field}
                  label="End-of-life assets"
                  type="text"
                  multiline
                  rows={2}
                  variant="outlined"
                  {...getFormErrorAttributes(fieldState.error)}
                />
                <FormHelperText>{fieldState.error?.message ?? getDescription(field.name)}</FormHelperText>
              </FormControl>
            )}
          />
          <Controller
            control={control}
            name="other.unvisitedRooms"
            disabled={disableForm}
            rules={{ maxLength: 120 }}
            render={({ field, fieldState }) => (
              <FormControl
                fullWidth
                {...getFormErrorAttributes(fieldState.error)}>
                <TextField
                  {...field}
                  label="Unvisited rooms"
                  type="text"
                  multiline
                  rows={2}
                  variant="outlined"
                  {...getFormErrorAttributes(fieldState.error)}
                />
                <FormHelperText>{fieldState.error?.message ?? getDescription(field.name)}</FormHelperText>
              </FormControl>
            )}
          />
          <Controller
            control={control}
            name="other.extraDescription"
            disabled={disableForm}
            rules={{ maxLength: 120 }}
            render={({ field, fieldState }) => (
              <FormControl
                fullWidth
                {...getFormErrorAttributes(fieldState.error)}>
                <TextField
                  {...field}
                  label="Extra description"
                  type="text"
                  multiline
                  rows={2}
                  variant="outlined"
                  {...getFormErrorAttributes(fieldState.error)}
                />
                <FormHelperText>{fieldState.error?.message ?? getDescription(field.name)}</FormHelperText>
              </FormControl>
            )}
          />
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
};
